<div class="w-full max-w-lg">
  <div class="flex items-start">
    @if (data.severity === 'danger') {
      <div class="mx-auto flex size-9 shrink-0 items-center justify-center rounded-full bg-[#ffe2e2] dark:bg-[#3b2626]">
        <svg
          class="size-6 text-[#e7000b] dark:text-[#e63d24]"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          aria-hidden="true"
          data-slot="icon"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
          />
        </svg>
      </div>
    }
    <div class="ml-4">
      @if (data.title) {
        <h3>{{ data.title }}</h3>
      }
      @if (data.message) {
        <div class="text-sm text-grey-700 dark:text-grey-200 mt-2 whitespace-pre-line" [innerText]="data.message"></div>
      }
      @if (data.footer) {
        <div class="text-sm text-grey-700 dark:text-grey-200 mt-5">{{ data.footer }}</div>
      }
    </div>
  </div>
  <div class="flex gap-2 justify-end mt-7">
    @if (data.allowCancel || data.cancelText) {
      <button class="btn btn-secondary" (click)="cancel()">{{ data.cancelText ?? 'Abbrechen' }}</button>
    }
    @switch (data.severity) {
      @case ('danger') {
        <button class="btn btn-error" (click)="confirm()">{{ data.confirmText ?? 'Bestätigen' }}</button>
      }
      @default {
        <button class="btn btn-primary" (click)="confirm()">{{ data.confirmText ?? 'Bestätigen' }}</button>
      }
    }
  </div>
</div>
